<template>
  <v-sheet v-if="vehicle.decommissioningDate" rounded class="mx-4 mb-8 mt-6 red lighten-3">
    <v-row align="center">
      <v-col class="grow">
        <div class="ma-4">
          <div class="font-weight-black">
            <v-icon left color="error">mdi-logout</v-icon>
            {{
              $t("components.thg.ThgMyVehicleRenewalOptionsSheet.vehicleDeregistered", {
                decommissioningDateReadable: vehicle.decommissioningDateReadable
              })
            }}
          </div>
          <div class="text-caption">
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.vehicleDeregisteredCaption") }}
          </div>
        </div>
      </v-col>

      <v-col class="shrink">
        <v-btn class="ma-4" color="error" @click="reDecommission" :loading="isLoading">
          {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.activateVehicleButton") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>

  <v-sheet v-else-if="vehicle.isAutoRenewal" rounded class="mx-4 mb-8 mt-6 light-green accent-1">
    <v-row align="center">
      <v-col class="grow">
        <div class="mx-4">
          <div class="font-weight-black">
            <v-icon left color="success">mdi-autorenew</v-icon>
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.autoRenewalActivated") }}
          </div>
          <div class="text-caption">
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.autoRenewalCaption") }}
          </div>
        </div>
      </v-col>

      <v-col class="shrink">
        <v-btn class="ma-4" color="success" @click="setAutoRenewal(false)" :loading="isLoading">
          {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.deactivateAutoRenewalButton") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>

  <v-sheet v-else-if="latestQuickCheckoutOption" outlined rounded class="mx-4 mb-6 mt-4 border-light-green">
    <v-row align="center">
      <v-col class="grow">
        <div class="ma-4">
          <div class="font-weight-black">
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.applyThgPremium") }}
          </div>
          <div class="text-caption">
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.applyThgPremiumCaption") }}
          </div>
        </div>
      </v-col>

      <v-col class="shrink">
        <thg-quick-checkout class="mx-4" :thg="latestQuickCheckoutOption" />
      </v-col>
    </v-row>
  </v-sheet>

  <v-sheet v-else rounded outlined class="mx-4 mb-6 mt-4 border-light-green">
    <v-row align="center">
      <v-col class="grow">
        <div class="ma-4">
          <div class="font-weight-black">
            <v-icon left color="success">mdi-autorenew</v-icon>
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.activateAutoRenewal") }}
          </div>
          <div class="text-caption">
            {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.activateAutoRenewalCaption") }}
          </div>
        </div>
      </v-col>

      <v-col class="shrink">
        <v-btn class="ma-4" color="success" @click="setAutoRenewal(true)" :loading="isLoading">
          {{ $t("components.thg.ThgMyVehicleRenewalOptionsSheet.activateAutoRenewalButton") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { IThgMyVehicle } from "@/models/thg-my-vehicle.entity";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import ThgQuickCheckout from "./ThgQuickCheckout.vue";
import { handleError } from "@/lib/utility/handleError";

@Component({
  components: {
    ThgQuickCheckout
  }
})
export default class ThgMyVehicleRenewalOptionsSheet extends DarkModeHighlightMixin {
  @Prop()
  vehicle!: IThgMyVehicle;

  @Prop()
  thgs!: ThgThgMeViewModelGen[];

  isLoading = false;

  get latestQuickCheckoutOption(): ThgThgMeViewModelGen | undefined {
    for (const thg of this.thgs) {
      if (thg.quickCheckoutEnabledFor?.length) {
        return thg;
      }
    }
    return undefined;
  }

  async setAutoRenewal(value: boolean) {
    if (!this.vehicle) {
      return;
    }
    this.isLoading = true;
    this.vehicle.isAutoRenewal = value;
    await this.vehicle.update().catch(handleError);

    this.isLoading = false;
  }

  async reDecommission() {
    if (!this.vehicle) {
      return;
    }
    this.isLoading = true;
    this.vehicle.decommissioningDate = undefined;

    await this.vehicle.update().catch(handleError);

    this.isLoading = false;
  }
}
</script>
<style scoped>
.border-light-green {
  border-color: #70cd00 !important;
}
</style>
